import { authRoles } from 'src/app/auth';
import Skills from './Skills';

const SkillsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.admin,
  routes: [
    {
      path: 'admin/skills',
      element: <Skills />,
    },
  ],
};

export default SkillsConfig;
